import { ethers } from 'ethers'

const TRANSFER_TOPIC = ethers.utils.id('Transfer(address,address,uint256)').toLowerCase()

function normalizeAddress(value) {
    try {
        return ethers.utils.getAddress(value).toLowerCase()
    } catch (_error) {
        return ''
    }
}

function readParsedTransfer(log) {
    const from = log?.args?.from ?? log?.args?.[0]
    const to = log?.args?.to ?? log?.args?.[1]
    const tokenId = log?.args?.tokenId ?? log?.args?.[2]
    if (!from || !to || tokenId === undefined) return null
    return { from, to, tokenId: tokenId.toString() }
}

function readRawTransfer(log) {
    const topics = log?.topics || []
    if (String(topics[0] || '').toLowerCase() !== TRANSFER_TOPIC || topics.length < 4) return null
    try {
        return {
            from: ethers.utils.getAddress(`0x${topics[1].slice(-40)}`),
            to: ethers.utils.getAddress(`0x${topics[2].slice(-40)}`),
            tokenId: ethers.BigNumber.from(topics[3]).toString(),
        }
    } catch (_error) {
        return null
    }
}

export function extractMintedTokenIds(receipt, contractAddress, recipient) {
    const expectedContract = normalizeAddress(contractAddress)
    const expectedRecipient = normalizeAddress(recipient)
    if (!expectedContract || !expectedRecipient) return []

    const logs = [...(receipt?.events || []), ...(receipt?.logs || [])]
    const seen = new Set()
    const tokenIds = []

    logs.forEach((log) => {
        if (normalizeAddress(log?.address) !== expectedContract) return
        const transfer = readParsedTransfer(log) || readRawTransfer(log)
        if (!transfer) return
        if (normalizeAddress(transfer.from) !== ethers.constants.AddressZero.toLowerCase()) return
        if (normalizeAddress(transfer.to) !== expectedRecipient || seen.has(transfer.tokenId)) return
        seen.add(transfer.tokenId)
        tokenIds.push(transfer.tokenId)
    })

    return tokenIds
}

export function buildMintPreview(tokenIds, limit = 6) {
    const uniqueIds = Array.from(new Set((tokenIds || []).map((tokenId) => tokenId.toString())))
    const previewIds = uniqueIds.slice(0, limit)
    return {
        count: uniqueIds.length,
        previewIds,
        remainingCount: Math.max(0, uniqueIds.length - previewIds.length),
    }
}
